import React, { useState } from "react";

export const Paragraph = ({
                       text,
                       type = "",
                       maxChars = 100,
                       shouldTruncateText = false,
                       viewMoreText = "Read More",
                       viewLessText = "Read Less",
                        classes="",
                   }) => {
    const [isExpanded, setIsExpanded] = useState(false);

    const toggleExpand = () => {
        setIsExpanded(!isExpanded);
    };

    const shouldTruncate = shouldTruncateText && maxChars > 0 && typeof text === 'string' && text.length > maxChars;
    const truncatedText = shouldTruncate
        ? text.substring(0, maxChars) + "..."
        : text;

    const renderText = () => {
        if (typeof text === "string") {
            // Render as plain text with truncation and expansion
            return (
                <>
                    <p
                        className={`${type} ${classes}`}
                        dangerouslySetInnerHTML={{
                            __html: (isExpanded || !shouldTruncate ? text : truncatedText).replace(
                                /\n/g,
                                "<br />"
                            ),
                        }}
                    />
                    {shouldTruncate && (
                        <a onClick={toggleExpand} className="underline mt-2 cursor-pointer block">
                            {isExpanded ? viewLessText : viewMoreText}
                        </a>
                    )}
                </>
            );
        } else if (Array.isArray(text)) {
            // Render each item in the array, checking if it's a valid React element or plain text
            return text.map((item, index) =>
                React.isValidElement(item) ? (
                    <React.Fragment key={index}>{item}</React.Fragment>
                ) : (
                    <p
                        key={index}
                        className={`${type} ${classes}`}
                        dangerouslySetInnerHTML={{
                            __html: item.replace(/\n/g, "<br />"),
                        }}
                    />
                )
            );
        } else {
            // Handle non-string, non-array cases as plain text
            return <p  className={`${type} ${classes}`}>{text}</p>;
        }
    };

    return <div>{renderText()}</div>;
};

export default Paragraph;
